import { X } from "lucide-react";
import type { Artist } from "../data";
import { ArtistDetailsForm } from "./Settings";

interface Props {
  artist: Artist;
  onClose: () => void;
}

export default function ArtistProfileModal({ artist, onClose }: Props) {
  return (
    <div className="modal-overlay" onClick={onClose} role="presentation">
      <div
        aria-labelledby="artist-profile-modal-title"
        aria-modal="true"
        className="modal-content artist-profile-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
      >
        <div className="modal-header">
          <div>
            <p className="eyebrow">Artist profile</p>
            <h2 id="artist-profile-modal-title">Edit {artist.name}</h2>
          </div>
          <button
            aria-label="Close artist profile editor"
            className="modal-close"
            onClick={onClose}
            type="button"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="modal-form artist-profile-modal-form">
          <p className="muted-copy">
            Update the profile details shown for this artist. Login access and passwords stay in Settings.
          </p>
          <ArtistDetailsForm selectedArtist={artist} />
        </div>
      </div>
    </div>
  );
}
